var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"signinBtn",staticClass:"loginBtn loginBtn--google"},[_vm._v(" Login with Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }